import postPic1 from '../img/374772596_623113343276722_5919751210009209983_n.jpg'
import postPic2 from '../img/IMG_20230913_164134.jpg'
import postPic3 from '../img/374772596_623113343276722_5919751210009209983_n.jpg'


export const PostsData = [
    {
        img: postPic1,
        name: 'Nick',
        desc: "Programming is like a hobby to those who have passion",
        likes: 2300,
        liked: true
    },
    {
        img: postPic2,
        name: 'okwesh',
        desc: "Thinking about how apps Works and the internet:)",
        likes: 2300,
        liked: false

    },
    {
        img:postPic3,
        name: "nick nick",
        desc: "Coding JavaScript React",
        likes: 800,
        liked: false
    }
]